<template>
  <div class="module">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>模块管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="模块名称：">
        <el-input size="small" v-model="formInline.module_name" placeholder="输入模块名称"></el-input>
      </el-form-item>
      <el-form-item label="模块编码：">
        <el-input size="small" v-model="formInline.module_code" placeholder="输入模块编码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search" v-auth="'moduleauth.list'">搜索
        </el-button>
        <el-button size="small" type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
        <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="handleEdit()"
          v-auth="'moduleauth.addorupdate'">添加模块</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="el-table-con">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;" @sort-change="sortChange">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="module_id" label="模块ID">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="module_name" label="模块名称">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="module_code" label="模块编码">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="module_name_parent" label="上级模块">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="ranking" label="排序">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="add_time" label="添加时间">
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)" v-auth="'moduleauth.addorupdate'">编辑</el-button>
            <el-button size="mini" icon="el-icon-refresh-right" type="success" @click="handleUpdate(scope.row)"
              v-auth="'moduleauth.updatethirdlevelmodule'">更新子模块
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="模块ID" prop="module_id" v-if="editForm.module_id">
          <el-input size="small" v-model="editForm.module_id" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="模块名称" prop="module_name">
          <el-input size="small" v-model="editForm.module_name" auto-complete="off" placeholder="请输入模块名称"></el-input>
        </el-form-item>
        <el-form-item label="模块编码" prop="module_code">
          <el-input size="small" v-model="editForm.module_code" auto-complete="off" placeholder="请输入模块编码"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="ranking">
          <el-input size="small" v-model="editForm.ranking" auto-complete="off" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="访问路径" prop="route">
          <el-input size="small" v-model="editForm.route" auto-complete="off" placeholder="请输入访问路径"></el-input>
        </el-form-item>
        <el-form-item label="图标Icon" prop="icon_url">
          <el-input size="small" v-model="editForm.icon_url" auto-complete="off" placeholder="请输入图标Icon">
          </el-input>
        </el-form-item>
        <el-form-item label="上级模块编码" prop="module_code_parent">
          <el-input size="small" v-model="editForm.module_code_parent" auto-complete="off" placeholder="请输入上级模块编码">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  let change = [];
  import {
    ModuleList,
    ModuleInfo,
    ModuleSave,
    ModuleUpdate
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    inject: ['reload'],
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加模块',
        editForm: {
          module_id: '',
          module_name: '',
          module_code: '',
          ranking: 0,
          route: '',
          module_code_parent: '',
          icon_url: ''
        },
        // rules 表单验证
        rules: {
          module_name: [
            { required: true, message: '请输入模块名称', trigger: 'blur' }
          ],
          module_code: [
            { required: true, message: '请输入模块编码', trigger: 'blur' }
          ]
        },
        formInline: {
          pageindex: 1,
          pagesize: 20,
          module_name: '',
          module_code: '',
          orderby: ''
        },
        listData: [], //模块数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    watch: {},

    /**
     * 创建完毕
     */

    created() { },
    mounted() {
      var formInline = localStorage.getItem('module')
      if (formInline) {
        this.formInline = JSON.parse(formInline)
      }
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */

    methods: {
      // 获取模块列表
      getdata(parameter) {
        var that = this;
        that.loading = true;
        ModuleList(parameter)
          .then(res => {
            that.loading = false
            if (res.statusCode == 200) {
              that.listData = res.data.datas
              // 分页赋值
              that.pageparm.currentPage = res.data.pageindex
              that.pageparm.pageSize = res.data.pagesize
              that.pageparm.total = res.data.rowscount
            } else {
              that.$message.error(res.message)
            }
          })
      },
      // 获取模块信息
      getModuleInfo(id) {
        var that = this;
        ModuleInfo({ module_id: id }).then(res => {
          if (res.statusCode == 200) {
            that.editForm = res.data;
          } else {
            that.$message.error(res.message)
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageindex = parm.currentPage
        this.formInline.pagesize = parm.pageSize
        localStorage.setItem('module', JSON.stringify(this.formInline))
        this.getdata(this.formInline)
      },
      // 排序
      sortChange(column, prop, order) {
        var order = '';
        if (column.order == 'ascending') {
          order = 'asc'
        } else if (column.order == 'descending') {
          order = 'desc'
        }
        if (order) {
          this.formInline.orderby = column.prop + ' ' + order
          this.search();
        }
      },
      // 搜索事件
      search() {
        this.formInline.pageindex = 1;
        localStorage.setItem('module', JSON.stringify(this.formInline))
        this.getdata(this.formInline)
      },
      // 重置
      reset() {
        this.formInline = {
          pageindex: 1,
          pagesize: 20,
          module_name: '',
          module_code: '',
          orderby: ''
        }
        // 重置清掉本地搜索缓存
        localStorage.removeItem('module')
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function (row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改模块'
          this.getModuleInfo(row.module_id);
        } else {
          this.title = '添加模块'
          this.editForm = {
            module_id: '',
            module_name: '',
            module_code: '',
            ranking: 0,
            route: '',
            module_code_parent: '',
            icon_url: ''
          }
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        var that = this;
        this.$refs[editData].validate(valid => {
          if (valid) {
            var editForm = that.editForm
            // 添加没有module_id
            if (!editForm.module_id) {
              delete editForm.module_id
            }
            ModuleSave(editForm)
              .then(res => {
                that.editFormVisible = false
                if (res.statusCode == 200) {
                  // 添加用户时清空搜索条件
                  if (that.title == '添加模块') {
                    that.reset();
                  } else {
                    that.getdata(that.formInline)
                  }
                  that.$message({
                    type: 'success',
                    message: that.title + '成功！'
                  })
                } else {
                  that.$message.error(res.message)
                }
              })
          } else {
            return false
          }
        })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      },
      // 更新子模块
      handleUpdate(row) {
        var that = this;
        ModuleUpdate({ module_code: row.module_code }).then(res => {
          if (res.statusCode == 200) {
            that.reset();
            that.$message({
              type: 'success',
              message: '更新成功！'
            })
          } else {
            that.$message.error(res.message)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
</style>
<style>
  .module .el-table-con {
    height: calc(100vh - 380px) !important;
  }

  .module .page-box {
    text-align: right !important;
  }

  /* 固定el-table头部 */
  .module .el-table {
    max-height: calc(100vh - 380px) !important;
  }

  .module .el-table__body-wrapper.is-scrolling-none {
    overflow-y: auto !important;
    max-height: calc(100vh - 465px) !important;
  }

  .module .el-dialog__body {
    max-height: 55vh;
    overflow-y: scroll;
  }

  .module .el-dialog__body::-webkit-scrollbar {
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/views/system/Module.vue